/* eslint-disable @typescript-eslint/naming-convention */
import { cva } from "class-variance-authority";

export const rootStyles = cva(
  ["grid w-full auto-cols-fr grid-rows-[auto_1fr_auto] place-content-start overflow-hidden rounded-lg"],
  {
    variants: {
      variant: {
        primary: "bg-white",
        secondary: "bg-neutral-98",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  }
);

export const headerStyles = cva("flex items-center justify-between p-4 pb-0", {
  variants: {
    variant: {
      primary: "",
      secondary: "",
    },
  },
});

export const bodyTitleStyles = cva("", {
  variants: {
    variant: {
      primary: "text-base leading-5 font-semibold text-neutral-30",
      secondary: "text-sm font-bold text-neutral-10",
    },
  },
  defaultVariants: {
    variant: "primary",
  },
});

export const bodyStyles = cva("flex flex-1 flex-col justify-start gap-4 overflow-y-auto p-4", {
  variants: {
    variant: {
      primary: "",
      secondary: "rounded-lg",
    },
  },
});

export const footerStyles = cva("flex flex-1 items-center self-end p-4", {
  variants: {
    variant: {
      primary: "",
      secondary: "rounded-lg",
    },
  },
});
